import React, {Component} from 'react';

import './index.less';
import {connect} from "react-redux";
import GlobalLoaderComponent from "components/ui/global-loader";
import {confirmEmailChangeCheck} from "store/reducers/mobile";
import * as alerts from "helpers/alerts";

@connect((state) => ({}), {confirmEmailChangeCheck})

export default class EmailChangeConfirmComponent extends Component {

    state = {
        loading: false,
    };

    async componentDidMount() {
        this.setState({loading: true});
        const response = await this.props.confirmEmailChangeCheck({
            new_email: this.props.params.email,
            new_email_activation_code: this.props.params.code,
        });
        this.setState({loading: false});
        if (response.isOk) {
            alerts.success('Email успешно изменен');
        } else {
            response.showErrors();
        }
    }

    render() {
        const loader = this.state.loading ? <GlobalLoaderComponent/> : null;

        return (
            <div className="EmailConfirm">
                {loader}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/modules/mobile/email-change-confirm/index.js